var map = {
	"./InterVE-Logo.png": 7872,
	"./images.png": 7625,
	"./logo_sin_fondo_recortado.png": 6988,
	"./logoempresa.jpeg": 1338,
	"./unnamed-removebg-preview.png": 5900,
	"./unnamed.jpg": 9491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1575;